var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCocoaPowder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C1;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#CF8874;}\n\t.st3{fill:#C06950;}\n\t.st4{fill:#90503D;}\n\t.st5{fill:#6F3423;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.19,185.11c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.89,150.81,62.5,185.11,105.19,185.11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.13,147.33c-52.6,0-59.78-31.24-59.78-39.57h119.57C163.91,111.92,157.03,147.33,104.13,147.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.91,106.53c0-13.2-26.77-23.9-59.78-23.9c-33.02,0-59.78,10.7-59.78,23.9c0,0.04,0.02,0.08,0.02,0.12 c0,0.05-0.02,0.08-0.02,0.13c0,13.2,26.77,23.9,59.78,23.9c33.02,0,59.78-10.7,59.78-23.9c0-0.04-0.02-0.08-0.02-0.12 C163.9,106.62,163.91,106.58,163.91,106.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.18,79.71c0,6.93-12.61,33-25.64,35.52c-7.33,1.42-16.8,2.37-23.67,2.93c-3.7-2.62-6.41-5.74-7.65-7.55 c-2.05-2.99,14.81-15.29,25.37-27.9c10.56-12.6,19.71-15.92,26.32-12.77c0.67,0.32,1.51,0.91,2.49,1.73c0,0,0,0.01,0.01,0.01v0.01 C114.1,74.07,115.18,76.61,115.18,79.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.36,111.66c-3.62,2.82-31.31,13.91-55.33,11.35c-0.01,0-0.01,0-0.01,0c-1.03-0.17-2.09-0.31-3.18-0.42 c-4.15-0.42-7.89-2.24-10.95-4.42c6.87-0.56,16.34-1.51,23.67-2.93c13.03-2.52,25.64-28.59,25.64-35.52 c0-3.11-1.09-5.64-2.77-8.03c4.93,4.11,13.26,13.86,20.76,22.49C135.56,100.12,138.15,109.49,135.36,111.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.57,122.74c-8.19,2.68-21.12,2.37-29.32,3.16c-7.22,0.69-13.58-1.67-21.23-2.89 c24.02,2.56,51.71-8.53,55.33-11.35c2.79-2.17,0.21-11.53-2.18-17.48c5.6,6.45,10.73,12.28,13.63,14.7 C154.38,115.18,138.77,120.07,130.57,122.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.29,112.06c1.26,0,1.26-1.96,0-1.96C69.03,110.1,69.03,112.06,70.29,112.06L70.29,112.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.17,117.18c1.26,0,1.26-1.96,0-1.96C73.92,115.22,73.91,117.18,75.17,117.18L75.17,117.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.61,105.83c1.26,0,1.26-1.96,0-1.96C79.35,103.87,79.35,105.83,80.61,105.83L80.61,105.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.37,114.11c1.26,0,1.26-1.96,0-1.96C85.11,112.15,85.1,114.11,86.37,114.11L86.37,114.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.3,120.73c1.26,0,1.26-1.96,0-1.96C92.04,118.77,92.04,120.73,93.3,120.73L93.3,120.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.46,121.04c1.26,0,1.26-1.96,0-1.96C105.2,119.08,105.2,121.04,106.46,121.04L106.46,121.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.61,121.36c1.26,0,1.26-1.96,0-1.96C124.35,119.4,124.35,121.36,125.61,121.36L125.61,121.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M123.56,111.35c1.26,0,1.26-1.96,0-1.96C122.3,109.39,122.3,111.35,123.56,111.35L123.56,111.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.33,109.14c1.26,0,1.26-1.96,0-1.96C119.07,107.18,119.07,109.14,120.33,109.14L120.33,109.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M134.04,105.6c1.26,0,1.26-1.96,0-1.96C132.78,103.64,132.78,105.6,134.04,105.6L134.04,105.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.11,107.49c1.26,0,1.26-1.96,0-1.96C138.85,105.53,138.85,107.49,140.11,107.49L140.11,107.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.91,115.53c1.26,0,1.26-1.96,0-1.96C136.65,113.57,136.64,115.53,137.91,115.53L137.91,115.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M127.66,94.56c1.26,0,1.26-1.96,0-1.96C126.4,92.61,126.4,94.56,127.66,94.56L127.66,94.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109.69,86.05c1.26,0,1.26-1.96,0-1.96C108.43,84.09,108.43,86.05,109.69,86.05L109.69,86.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.16,96.14c1.26,0,1.26-1.96,0-1.96C95.9,94.18,95.9,96.14,97.16,96.14L97.16,96.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.57,90.39c1.26,0,1.26-1.96,0-1.96C87.31,88.43,87.31,90.39,88.57,90.39L88.57,90.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.13,76.91c1.26,0,1.26-1.96,0-1.96C100.87,74.95,100.87,76.91,102.13,76.91L102.13,76.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.97,84.63c1.26,0,1.26-1.96,0-1.96C116.71,82.68,116.71,84.63,117.97,84.63L117.97,84.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.25,98.9c1.26,0,1.26-1.96,0-1.96C118.99,96.94,118.99,98.9,120.25,98.9L120.25,98.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.37,108.51c1.26,0,1.26-1.96,0-1.96C111.11,106.55,111.11,108.51,112.37,108.51L112.37,108.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.66,102.76c1.26,0,1.26-1.96,0-1.96C94.41,100.8,94.4,102.76,95.66,102.76L95.66,102.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.62,80.53c1.26,0,1.26-1.96,0-1.96C105.36,78.58,105.36,80.53,106.62,80.53L106.62,80.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.05,91.96c1.26,0,1.26-1.96,0-1.96C100.79,90,100.79,91.96,102.05,91.96L102.05,91.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.71,87c1.26,0,1.26-1.96,0-1.96C96.45,85.04,96.45,87,97.71,87L97.71,87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.36,96.85c1.26,0,1.26-1.96,0-1.96C88.1,94.89,88.1,96.85,89.36,96.85L89.36,96.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.43,94.09c1.26,0,1.26-1.96,0-1.96C78.17,92.13,78.17,94.09,79.43,94.09L79.43,94.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.2,101.89c1.26,0,1.26-1.96,0-1.96C71.95,99.93,71.94,101.89,73.2,101.89L73.2,101.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.34,101.26c1.26,0,1.26-1.96,0-1.96C84.08,99.3,84.08,101.26,85.34,101.26L85.34,101.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.76,119.23c1.26,0,1.26-1.96,0-1.96C130.5,117.27,130.5,119.23,131.76,119.23L131.76,119.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.66,111.74c1.26,0,1.26-1.96,0-1.96C142.4,109.79,142.4,111.74,143.66,111.74L143.66,111.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.67,97.32c1.26,0,1.26-1.96,0-1.96C104.41,95.36,104.41,97.32,105.67,97.32L105.67,97.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.59,111.35c1.26,0,1.26-1.96,0-1.96C139.33,109.39,139.32,111.35,140.59,111.35L140.59,111.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.64,112.37c1.26,0,1.26-1.96,0-1.96C109.38,110.42,109.38,112.37,110.64,112.37L110.64,112.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.08,91.41c1.26,0,1.26-1.96,0-1.96C114.82,89.45,114.81,91.41,116.08,91.41L116.08,91.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.6,101.6c0.05,0.05,0.11,0.11,0.16,0.16c0.09,0.1,0.19,0.16,0.31,0.2c0.12,0.06,0.24,0.09,0.38,0.08 c0.13,0.01,0.26-0.02,0.38-0.08c0.12-0.04,0.23-0.11,0.31-0.2c0.05-0.07,0.1-0.13,0.15-0.2c0.09-0.15,0.13-0.32,0.13-0.49 c-0.01-0.09-0.02-0.17-0.03-0.26c-0.05-0.17-0.13-0.31-0.25-0.43c-0.05-0.05-0.11-0.11-0.16-0.16c-0.09-0.1-0.19-0.16-0.31-0.2 c-0.12-0.06-0.24-0.09-0.38-0.08c-0.13-0.01-0.26,0.02-0.38,0.08c-0.12,0.04-0.23,0.11-0.31,0.2c-0.05,0.07-0.1,0.13-0.15,0.2 c-0.09,0.15-0.13,0.32-0.13,0.49c0.01,0.09,0.02,0.17,0.03,0.26C127.39,101.34,127.48,101.48,127.6,101.6L127.6,101.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.6,122.3c1.26,0,1.26-1.96,0-1.96C114.34,120.35,114.34,122.3,115.6,122.3L115.6,122.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.62,109.14c1.26,0,1.26-1.96,0-1.96C92.36,107.18,92.35,109.14,93.62,109.14L93.62,109.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.41,110.17c1.26,0,1.26-1.96,0-1.96C106.15,108.21,106.15,110.17,107.41,110.17L107.41,110.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.68,100.24c1.26,0,1.26-1.96,0-1.96C114.42,98.28,114.42,100.24,115.68,100.24L115.68,100.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.96,110.17c1.26,0,1.26-1.96,0-1.96C103.7,108.21,103.7,110.17,104.96,110.17L104.96,110.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.78,94.96c1.26,0,1.26-1.96,0-1.96C105.52,93,105.52,94.96,106.78,94.96L106.78,94.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129,107.09c1.26,0,1.26-1.96,0-1.96C127.74,105.14,127.74,107.09,129,107.09L129,107.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.87,73.99c1.26,0,1.26-1.96,0-1.96C109.62,72.04,109.61,73.99,110.87,73.99L110.87,73.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.85,78.8c1.26,0,1.26-1.96,0-1.96C95.59,76.84,95.59,78.8,96.85,78.8L96.85,78.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.91,82.58c1.26,0,1.26-1.96,0-1.96C88.65,80.63,88.65,82.58,89.91,82.58L89.91,82.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.1,115.84c1.26,0,1.26-1.96,0-1.96C99.84,113.88,99.84,115.84,101.1,115.84L101.1,115.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.21,101.66c1.26,0,1.26-1.96,0-1.96C100.95,99.7,100.94,101.66,102.21,101.66L102.21,101.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.77,102.44c1.26,0,1.26-1.96,0-1.96C108.51,100.49,108.51,102.44,109.77,102.44L109.77,102.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.2,85.74c1.26,0,1.26-1.96,0-1.96C103.94,83.78,103.94,85.74,105.2,85.74L105.2,85.74z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.9,100.76c0,3.89-6.41,36.92-55.76,36.92c-49.1,0-55.79-29.17-55.79-36.92h0.06 c1.2,11.9,25.7,21.39,55.74,21.39c30.01,0,54.5-9.49,55.71-21.39H159.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocoaPowder);
export default __webpack_public_path__ + "static/media/Cocoa_powder.e658991254af1b2fdce2ad5656594a3b.svg";
export { ForwardRef as ReactComponent };